import getEventValue from 'helpers/get-event-value';

export default function handleFileChange(event, setFields) {
  const value = getEventValue(event);
  setFields({ video: value, videoChanged: true });
}
